// Careful the Dial component requeries MAX AND MIN values to be divisible by STEP
export const MAX_PROD_TEMP_F = 200
export const MIN_PROD_TEMP_F = 0
export const PROD_TEMP_STEP_F = 1
export const MAX_GRILL_TEMP_F = 700
export const MIN_GRILL_TEMP_F = 0
export const GRILL_TEMP_STEP_F = 1  
export const MIN_TIME_S = 0
export const MAX_TIME_S = 1800
export const TIME_STEP_S = 10

export const CATEGORIES = {
    STEAK: 'Steak',
    CHICKEN : 'Chicken',
    FISH: 'Fish',
    BURGUER: 'Burguer',
    TURKEY: 'Turkey',
    PORK: 'Pork'
}

export const TERMS = {
    RAW: 'RAW',
    RARE: 'RARE',
    MEDIUM_RARE: 'MEDIUM RARE',
    MEDIUM: 'MEDIUM',
    MED_WELL: 'MED WELL',
    WELL_DONE: 'WELL DONE'
}

export const getCookingTerm = (category, temperature) => {
    switch(category){
        case CATEGORIES.STEAK:
            if(temperature > 124 && temperature < 135)
                return 'Rare'
            else if(temperature >= 135 && temperature < 145)
                return 'Medium Rare'
            else if(temperature >= 145 && temperature <= 150)
                return 'Medium Well'
            else if(temperature > 150 && temperature <= 155)
                return 'Well Done'
            else
                return '';
        case CATEGORIES.CHICKEN:
            if (temperature > 0 && temperature <= 155)
                return 'Raw'
            else if (temperature > 155 && temperature <= 165)
                return 'Just Cooked'
            else if (temperature > 165 && temperature <= 167)
                return 'Well Done'
            else
                return ''
        default: 
            return ''
    }
}


// Recipes constants
export const ACTIONS_REQUIRED = {
    TURN_PROD : 'Turn Product',
    ROTATE: 'Rotate',
    ADD_SAUCE: 'Add Sauce',
    REMOVE_PROD: 'Remove Product'
}